import React, { Fragment, useState } from 'react';

import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';

import * as ST from './styled';

interface IAnswer {
    title?: string,
    text?: string,
}

export interface IQuestion {
    id: number,
    question: string,
    answers: IAnswer[],
}

interface IProps {
    questions: IQuestion[],
}

export enum EMediaWidth {
    minMobile = '(min-width: 767px)',
    laptop = '(max-width: 1279px)',
}

const QuestionsBlock: React.FC<IProps> = ({ questions = [] }): JSX.Element => {

    const [currentIdx, setCurrentIdx] = useState(0);

    return (
        <ST.Wrapper data-test='questions-block'>
            <WideContainer>
                <ST.HeadTitle data-test='features-block-title'>Если остались вопросы</ST.HeadTitle>
                {
                    questions.map((item) => {
                        return (
                            <ST.SAccordion
                                key={item.id}
                                title={item.question}
                                open={item.id === currentIdx}
                                toggle={() => item.id !== currentIdx ? setCurrentIdx(item.id) : setCurrentIdx(0)}
                            >
                                {item.answers?.map((item, idx) => {
                                    return (
                                        <Fragment key={idx}>
                                            <ST.TextLine dangerouslySetInnerHTML={{ __html: item.title || '' }}/>
                                            <ST.TextLine dangerouslySetInnerHTML={{ __html: item.text || '' }}/>
                                        </Fragment>
                                    );
                                })}
                            </ST.SAccordion>
                        );
                    })
                }
            </WideContainer>
        </ST.Wrapper>
    );
};

export default QuestionsBlock;
